module.exports = __webpack_public_path__ + "static/media/history-top.c69803d2.jpg";